import { getAPI, token } from "@/api/params.js";

export const uploadFile = (stream, url, clearFiles, uploadingIdShange) => {
  return fetch(
    `${getAPI()}/video/uploader/get_uploading_link?token=${token}&app=ndvr${
      stream !== "No Stream" && stream !== undefined ? `&stream=${stream}` : ""
    }`,
    {
      method: "POST",
      body: JSON.stringify({
        items: [{ fileName: url }]
      }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }
  )
    .then(response => response.json())
    .then(function(commits) {
      if (commits.success === true) {
        clearFiles();
      } else {
        throw new Error(commits.error);
      }
      const uploadingLinkUrl = commits.data.uploadingUrl;
      uploadingIdShange(commits.data.item.map(e => e.videoId));

      function postData(url, data, onProgress) {
        return new Promise(function(resolve, reject) {
          const request = new XMLHttpRequest();
          request.open("POST", url);
          request.onprogress = function(e) {
            const percent_completed = (e.loaded / e.total) * 100;
            onProgress(percent_completed);
          };
          request.onerror = reject;
          request.addEventListener("readystatechange", function(e) {
            console.warn(request.readyState);
            if (request.status < 300) {
              resolve({
                status: request.status,
                response: request.response
              });
            } else {
              reject({
                status: request.status,
                response: request.response
              });
            }
          });
          request.send(data);
        });
      }

      return Promise.all(
        commits.data.item.map((item, index) => {
          const formdata = new FormData();
          formdata.append("token", item.uploadingToken);
          formdata.append("callback_url", item.callbackUrl);
          formdata.append("file_url", url);

          return postData(uploadingLinkUrl, formdata, function(e) {});
        })
      );
    });
};
